const PROPOSAL_PATH = "/vision/proposta";

/**
 * Single source of truth for the client-facing proposal URL.
 *
 * Every proposal shares /vision/proposta since PED-12653 — the template is
 * picked by ProposalRoutePage from the fetched payload's own proposal_type,
 * not by the URL (/vision/proposta-smb survives only as an alias for
 * already-sent SMB links). The URL must never depend on how the proposal
 * was generated (manual flow vs automated/Bruna) nor on a backend-stored
 * absolute URL — stored URLs pointed to dead hosts and leaked production
 * links into staging.
 *
 * The base comes from VITE_VISION_PROPOSAL_URL, which historically is set
 * either as a bare host or already suffixed with /vision/proposta, so both
 * shapes are normalized here.
 */
export function getProposalUrl(uuid: string): string {
  const configuredBase = import.meta.env.VITE_VISION_PROPOSAL_URL;
  const base = (
    configuredBase ?? `${window.location.origin}${PROPOSAL_PATH}`
  ).replace(/\/+$/, "");
  const proposalBase = base.endsWith(PROPOSAL_PATH)
    ? base
    : `${base}${PROPOSAL_PATH}`;
  return `${proposalBase}/${uuid}`;
}
